import { SmallButton } from "@sellar-io/components";
import { ReactElement, useEffect } from "react";
import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../components";

import { useDashboardContext } from "../../components/dashboard/Dashboard.shared";
import { NavigationBar } from "../../components/navigation/NavigationBar";
import {
  CUSTOMER,
  DIRECT_MESSAGE,
  DIRECT_MESSAGE_LIST,
  ORDER_SUPPLIER,
  ORDER_BUYER,
  BUYER,
  BUYERS,
} from "../../constants/routes";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useRelationship } from "../../hooks/api/v2/relationship/useRelationship";
import { useParentNavigation } from "../../hooks/useParentNavigation";
import { useParamAsNumber } from "../../hooks/useParamAsNumber";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { MessageThread } from "./MessageThread";

export function MessageThreadPage(): ReactElement {
  const { business } = useSellarCurrentBusiness();
  const navigate = useNavigate();
  const { isTwoPanel } = useDashboardContext();
  const relationshipId = useParamAsNumber(DIRECT_MESSAGE, "relationshipId");
  const navigateToParent = useParentNavigation({
    fallback: DIRECT_MESSAGE_LIST,
  });
  const relationshipQuery = useRelationship(relationshipId);

  const errorMessage = apiV2AssertError(relationshipQuery.error)?.response?.data
    .message;
  useEffect(() => {
    // if the relationship can not be found, its probably due to the user clicking on an old email
    // redirect to list page
    if (errorMessage === "No relationship found") {
      navigate(DIRECT_MESSAGE_LIST);
    }
  }, [errorMessage, navigate]);

  const getSupplierCustomerUrl = () => {
    const connectionId = relationshipQuery.data?.SupplierRetailerConnection?.id;
    const buyerId = relationshipQuery.data?.BuyerId;
    if (connectionId) {
      return CUSTOMER.href({ connectionId });
    }

    return buyerId ? BUYER.href({ buyerId }) : BUYERS;
  };

  return (
    <>
      <NavigationBar
        title={
          relationshipQuery.isLoading
            ? "Loading..."
            : business?.type === "supplier"
              ? relationshipQuery.data?.Retailer.Business.name
              : relationshipQuery.data?.Supplier.Business.name
        }
        onClickTitle={() =>
          navigate(
            business?.type === "supplier"
              ? getSupplierCustomerUrl()
              : ORDER_BUYER.href({
                  supplierIdOrUrlId:
                    relationshipQuery.data?.Supplier.urlId ?? "undefined",
                }),
          )
        }
        leftIcon={"CHEVRON_LEFT"}
        rightComponent={
          relationshipQuery.data?.SupplierRetailerConnection?.approved &&
          relationshipQuery.data.SupplierRetailerConnection.id &&
          (business?.Supplier || true) ? (
            <SmallButton
              onClick={() =>
                navigate(
                  business?.Supplier?.id &&
                    relationshipQuery.data.SupplierRetailerConnection?.id
                    ? ORDER_SUPPLIER.href({
                        connectionId:
                          relationshipQuery.data.SupplierRetailerConnection.id,
                      })
                    : ORDER_BUYER.href({
                        supplierIdOrUrlId:
                          relationshipQuery.data.Supplier.urlId,
                      }),
                )
              }
            >
              Place order
            </SmallButton>
          ) : null
        }
        onClickLeftIcon={isTwoPanel ? undefined : navigateToParent}
      />
      {relationshipQuery.isLoading ? (
        <SpinnerLegacy />
      ) : (
        <>
          <MessageThread
            relationshipId={relationshipId}
            flaggedAsBadPayer={
              relationshipQuery.data?.Retailer.flaggedAsBadPayer
            }
          />
        </>
      )}
    </>
  );
}
